export default "__VITE_ASSET__G2JeNmXW__"